<template>
  <div v-show="visible" ref="watermark" class="global-watermark" :style="watermarkStyle"></div>
</template>

<script>
export default {
  name: 'GlobalWatermark',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      backgroundImage: ''
    }
  },
  computed: {
    watermarkStyle() {
      return {
        backgroundImage: this.backgroundImage
      }
    }
  },
  watch: {
    content: {
      deep: true,
      handler() {
        this.drawWatermark()
      }
    }
  },
  mounted() {
    document.body.appendChild(this.$el)
    this.drawWatermark()
  },
  beforeDestroy() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el)
    }
  },
  methods: {
    drawWatermark() {
      const lines = this.content
        .map(item => String(item || '').trim())
        .filter(Boolean)

      if (!lines.length) {
        this.backgroundImage = ''
        return
      }

      const canvas = document.createElement('canvas')
      const ratio = window.devicePixelRatio || 1
      const width = 300
      const height = 190
      canvas.width = width * ratio
      canvas.height = height * ratio

      const context = canvas.getContext('2d')
      context.scale(ratio, ratio)
      context.translate(width / 2, height / 2)
      context.rotate(-22 * Math.PI / 180)
      context.fillStyle = 'rgba(0, 0, 0, 0.12)'
      context.font = '14px Arial, "Microsoft YaHei", sans-serif'
      context.textAlign = 'center'
      context.textBaseline = 'middle'

      const lineHeight = 24
      const startY = -((lines.length - 1) * lineHeight) / 2
      lines.forEach((line, index) => {
        context.fillText(line, 0, startY + index * lineHeight)
      })

      this.backgroundImage = `url(${canvas.toDataURL('image/png')})`
    }
  }
}
</script>

<style>
.global-watermark {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  pointer-events: none;
  background-repeat: repeat;
}
</style>



// WEBPACK FOOTER //
// src/components/GlobalWatermark/index.vue